import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OneXPageContainer from "./OneX/OneXPageContainer";
import GetSavedQuotes from "./Templates/GetSavedQuotes";
import SavedQuotesList from "./Templates/SavedQuotesList";
import QuoteUnavailable from "./Templates/QuoteUnavailable";
import Error from "./Templates/Error";
import { useRecoilValue } from "recoil";
import { staticAppConfig } from "./AppData/Recoil";
import OneXModal from "./OneX/OneXModal";
import Auth from "./Templates/Auth";

const ApplicationContainer = () => {
  const [init, setInit] = useState(false);
  const fifteenMinutes = 900000;
  const oneMinute = 60000;

  let timer;

  const appConfig = useRecoilValue(staticAppConfig);

  let redirectRoute = appConfig.routes.landing;

  let params = new URLSearchParams(document.location.search.substring(1));
  let cmpId = params.get('cmpid');

  if(null != cmpId) {
    redirectRoute = `${appConfig.routes.landing}/?cmpid=${cmpId}`
  }

  console.log(`redirectRoute:${redirectRoute}`);

  const setTimeoutHandler = () => {
    timer = setTimeout(() => {
      if(window.location.href !== `${appConfig.routes.noQuotes}`) {
        window.oneX.Modal.showModal(window.document.activeElement, "timeoutModal");
        clearTimeout(timer);
        timer = setTimeout(() => {
          window.location.reload();
        }, oneMinute);
      }
      else {
        window.location.reload();
      }
    }, fifteenMinutes);
  };

  const handleEnterKey = (event) => {
    if (event.key === "Enter") {
      modalButtonHandler();
    }
  };

  const modalButtonHandler = () => {
    clearTimeout(timer);
    window.oneX.Modal.hideModal();
    setTimeoutHandler();
  };

  useEffect(() => {
    if (!init) {
      setInit(true);
    }
  }, [init]);

  return (
    <OneXPageContainer>
      <OneXModal
        id={"timeoutModal"}
        title={"Session Ending"}
        body={"Please confirm you are there by clicking Continue"}
        primaryId={"timeoutModalPrimaryBtn"}
        primaryClickHandler={modalButtonHandler}
        primaryKeyPress={handleEnterKey}
        primaryLabel={"Continue"}
      /> 
      {init ?
        setTimeoutHandler() : null
      }
      <BrowserRouter>
          <Routes>
            <Route exact path={`${appConfig.routes.landing}`} element={<GetSavedQuotes id={"getSavedQuoteScreen"} />} />
            <Route exact path={`${appConfig.routes.noQuotes}`} element={<QuoteUnavailable />} />
            <Route exact path={`${appConfig.routes.quotesList}`} element={<SavedQuotesList id={"savedQuotesList"} />} />
            <Route exact path={`${appConfig.routes.shapeError}`} element={<Error id={"shapeError"} />} />
            <Route exact path={`${appConfig.routes.auth}`} element={<Auth />} />
          </Routes>
      </BrowserRouter>
    </OneXPageContainer>
  );
};

export default ApplicationContainer;
